// Names of the events to emit that have been configured in the WLL console
export enum RewardableEventType {
  ACHIEVED_TWENTY_PERCENT_SAVINGS = 'ACHIEVED_TWENTY_PERCENT_SAVINGS',
  ACTIVATED_FINANCIAL_HEALTH_SCORE = 'ACTIVATED_FINANCIAL_HEALTH_SCORE',
  ACTIVATED_TU = 'ACTIVATED_TU',
  ACQUIRED_IDENTITY_THEFT_PLAN = 'ACQUIRED_IDENTITY_THEFT_PLAN',
  BOOSTED_CS_AVERAGE_GOOD = 'BOOSTED_CS_AVERAGE_GOOD',
  BOOSTED_CS_GOOD_EXCELLENT = 'BOOSTED_CS_GOOD_EXCELLENT',
  BOOSTED_CS_POOR_AVERAGE = 'BOOSTED_CS_POOR_AVERAGE',
  CATEGORIZED_LAST_MONTH_TRANSACTIONS = 'CATEGORIZED_LAST_MONTH_TRANSACTIONS',
  CHECKED_AUTO_INSURANCE_POLICY = 'CHECKED_AUTO_INSURANCE_POLICY',
  CHECKED_PROPERTY_INSURANCE_POLICY = 'CHECKED_PROPERTY_INSURANCE_POLICY',
  COMPLETED_WEEKLY_INSIGHTS_STACK = 'COMPLETED_WEEKLY_INSIGHTS_STACK',
  ENABLED_PUSH_NOTIFICATIONS = 'ENABLED_PUSH_NOTIFICATIONS',
  FOUND_RETIREMENT_ACCOUNT_WITH_CAPITALIZE = 'FOUND_RETIREMENT_ACCOUNT_WITH_CAPITALIZE',
  IMPROVED_CREDIT_UTILIZATION_BELOW_TEN = 'IMPROVED_CREDIT_UTILIZATION_BELOW_TEN',
  IMPROVED_CREDIT_UTILIZATION_BELOW_THIRTY = 'IMPROVED_CREDIT_UTILIZATION_BELOW_THIRTY',
  IMPROVED_CREDIT_UTILIZATION_BELOW_ONE = 'IMPROVED_CREDIT_UTILIZATION_BELOW_ONE',
  LINKED_ALL_ACCOUNT_TYPES = 'LINKED_ALL_ACCOUNT_TYPES',
  LINKED_AUTO_INSURANCE_POLICY = 'LINKED_AUTO_INSURANCE_POLICY',
  LINKED_CREDIT_CARD_ACCOUNT = 'LINKED_CREDIT_CARD_ACCOUNT',
  LINKED_HOME_OR_RENTERS_INSURANCE_POLICY = 'LINKED_HOME_OR_RENTERS_INSURANCE_POLICY',
  LINKED_INVESTMENT_ACCOUNT = 'LINKED_INVESTMENT_ACCOUNT',
  LINKED_REDFIN_HOME_VALUE = 'LINKED_REDFIN_HOME_VALUE',
  LINKED_SAVINGS_ACCOUNT = 'LINKED_SAVINGS_ACCOUNT',
  LINKED_LOAN_ACCOUNT = 'LINKED_LOAN_ACCOUNT',
  LOGGED_INTO_NERDWALLET_WEB = 'LOGGED_INTO_NERDWALLET_WEB',
  LOGGED_INTO_NERDWALLET_APP = 'LOGGED_INTO_NERDWALLET_APP',
  REFERRED_A_USER = 'REFERRED_A_USER',
  ROLLED_OVER_RETIREMENT_ACCOUNT_WITH_CAPITALIZE = 'ROLLED_OVER_RETIREMENT_ACCOUNT_WITH_CAPITALIZE',
  USED_CREDIT_SIMULATOR = 'USED_CREDIT_SIMULATOR',
  VIEWED_CREDIT_SCORE = 'VIEWED_CREDIT_SCORE',
  VIEWED_FIFTY_THIRTY_TWENTY_BUDGET = 'VIEWED_FIFTY_THIRTY_TWENTY_BUDGET',
  VIEWED_WEEKLY_READS = 'VIEWED_WEEKLY_READS',
  LINKED_INSURANCE_POLICY_AGGREGATED = 'LINKED_INSURANCE_POLICY_AGGREGATED',
  //  Aggregated events
  NET_WORTH = 'NET_WORTH',
  CASH_FLOW = 'CASH_FLOW',
  TREASURY_ACCOUNT_FUNDED = 'TREASURY_ACCOUNT_FUNDED',
  TREASURY_ACCOUNT_FUNDS_HELD = 'TREASURY_ACCOUNT_FUNDS_HELD',
  PAID_ELIGIBLE_CREDIT_CARD_ON_TIME = 'PAID_ELIGIBLE_CREDIT_CARD_ON_TIME',
  ACTIVATED_ELIGIBLE_CREDIT_CARD = 'ACTIVATED_ELIGIBLE_CREDIT_CARD',
  ACQUIRED_ELIGIBLE_CREDIT_CARD = 'ACQUIRED_ELIGIBLE_CREDIT_CARD',
  ACTIVATED_ELIGIBLE_CREDIT_CARD_ONLINE = 'ACTIVATED_ELIGIBLE_CREDIT_CARD_ONLINE',
}
